<template>
  <div class="percentage_chart_base_container item_container_margin">
    <div class="summary_top">
      <div class="summary_text summary_text_weight_700">
        再資源率・リサイクルタイプ
      </div>
      <div class="top_button_container">
        <div
          class="top_button top_button_text top_button_left_border clickable"
          :style="{ background: getButtonColor(beforeSelectionVisibility) }"
          @click="toggleBeforeSelection()"
        >
          選別前
        </div>
        <div
          class="top_button top_button_text top_button_right_border clickable"
          :style="{ background: getButtonColor(afterSelectionVisibility) }"
          @click="toggleAfterSelection()"
        >
          選別後
        </div>
      </div>
    </div>
    <div class="bottom_container_total_chart">
      <RecyclePercentageChart
        v-bind:titleText="recyclePercentageChartTitle"
        v-bind:colorSet="recyclePercentageChartColorSet"
        v-bind:receivedData="recyclePercentageData"
        v-bind:displayMode="1"
      />
      <v-divider />
      <div v-if="beforeSelectionVisibility">
        <RecycleTypeBeforeSelectionChart
          titleText="リサイクルタイプ (選別前)"
          v-bind:receivedData="wasteRecycleTypeDataInGram"
          v-bind:displayMode="1"
          class="px-4 py-4"
        />
      </div>
      <div v-else>
        <RecycleTypeChart
          titleText="リサイクルタイプ (選別後)"
          v-bind:receivedData="resultRecycleTypeDataInGram"
          v-bind:displayMode="1"
          class="px-4 py-4"
        />
      </div>
    </div>
  </div>
</template>

<script>
import utils from '../../mixins/utils'
import RecyclePercentageChart from './RecyclePercentageChart'
import RecycleTypeChart from './RecycleTypeChart'
import RecycleTypeBeforeSelectionChart from './RecycleTypeBeforeSelectionChart'

export default {
  name: 'RecyclePercentageAndTypeChart',
  components: {
    RecyclePercentageChart,
    RecycleTypeChart,
    RecycleTypeBeforeSelectionChart
   },
  props: {
    receivedData: {
      type: Object,
      default: () => {}
    },
    titleText: {
      type: String,
      default: ''
    },
    colorSet: {
      type: Number,
      default: 0
    }
  },
  mixins: [utils],
  watch: {
    receivedData: function() {
      this.refreshChart()
    }
  },
  data() {
    return {
      beforeSelectionVisibility: true,
      afterSelectionVisibility: false,
      recyclePercentageChartTitle: "再資源率（選別前）",
      recyclePercentageChartColorSet: 0,
      recyclePercentageData: {},
      wasteRecycleTypeDataInGram: {},
      resultRecycleTypeDataInGram: {},
    }
  },
  mounted() {
    this.refreshChart()
  },
  methods: {
    refreshChart() {
      this.wasteRecycleTypeDataInGram = this.receivedData.wasteRecycleTypeDataInGram
      this.resultRecycleTypeDataInGram = this.receivedData.resultRecycleTypeDataInGram

      this.recyclePercentageData = this.beforeSelectionVisibility ?
        this.wasteRecycleTypeDataInGram : this.resultRecycleTypeDataInGram
      this.recyclePercentageChartTitle = this.beforeSelectionVisibility ? "再資源率（選別前）" : "再資源率（選別後）"
      this.recyclePercentageChartColorSet = this.beforeSelectionVisibility ? 0 : 1
    },
    getTotal(jsonObject) {
      if(jsonObject == null) {
        return 0
      }
      let total = 0
      for (var item in jsonObject) {
        total += jsonObject[item] / 1000 // gram to kg
      }
      return total
    },
    getButtonColor(value) {
      if(value) {
        return '#0e5df014'
      } else {
        return '#FFFFFF'
      }
    },
    toggleBeforeSelection() {
      this.beforeSelectionVisibility = !this.beforeSelectionVisibility
      this.afterSelectionVisibility = !this.beforeSelectionVisibility
      this.refreshChart()
    },
    toggleAfterSelection() {
      this.afterSelectionVisibility = !this.afterSelectionVisibility
      this.beforeSelectionVisibility = !this.afterSelectionVisibility
      this.refreshChart()
    },
  }
}
</script>

<style scoped>
.bottom_container_total_chart {
  border-top: solid 1px rgba(52, 58, 63, 0.1);
  padding: 15px 15px;
  text-align: center;
}

.total_chart_value_text {
  font-family: "SF Pro";
  font-style: normal;
  font-weight: 600;
  font-size: 48px;
  line-height: 56px;
  text-align: center;
  color: #005061;
}

.explain_text {
  font-family: "SF Pro";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  letter-spacing: 0.4px;
  color: #343a3f;
  margin-top: 8px;
}

.total_chart_graph {
  border-radius: 8px;
  display: grid;
  grid-template-rows: 2fr 4fr 1fr;
  box-sizing: border-box;
}

.percentage_chart_base_container {
  max-width: 100%;
  width: 1408px;
  height: 634px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.19), 0 2px 2px rgba(0, 0, 0, 0.23);
  border-radius: 12px;
  background-color: #ffffff;
}

.item_container_margin {
  margin-left: auto;
  margin-right: auto;
}

.summary_top {
  display: grid;
  padding: 15px 15px;
  grid-template-columns: 1fr 1fr;
}

.summary_text {
  justify-content: center;
  flex-direction: column;
  display: flex;
}

.summary_text_weight_700 {
  font-family: "SF Pro";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 32px;
  letter-spacing: 0.15px;
  color: #000000;
}

.summary_menu_container {
  justify-content: center;
  flex-direction: column;
  display: flex;
  align-items: end;
}

.width_auto {
  width: auto;
}

.bar_chart_container {
  width: 100%;
  height: 44px;
  display: inline-flex;
  box-sizing: border-box;
  margin-top: 30px;
  border-radius: 8px;
}

.chart_percentage_bar {
  border-radius: 8px 0px 0px 8px;
  transform: matrix(1, 0, 0, -1, 0, 0);
}

.top_button_container {
  width: 100%;
  display: flex;
  justify-content: right;
  align-items: center;
}

.top_button {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 6px 12px;
  gap: 10px;
  width: 70px;
  height: 32px;
  background: rgba(14, 93, 240, 0.08);

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
}

.top_button_left_border {
  border: 1px solid #d0dcf2;
  border-bottom-left-radius: 6px;
  border-top-left-radius: 6px;
}

.top_button_right_border {
  border-top: 1px solid #d0dcf2;
  border-right: 1px solid #d0dcf2;
  border-bottom: 1px solid #d0dcf2;
  border-bottom-right-radius: 6px;
  border-top-right-radius: 6px;
}

.top_button_text {
  font-family: "SF Pro";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  /* identical to box height, or 143% */
  /* Light/Primary/Main */
  color: #0e5df0;
}
</style>
